module.exports = __webpack_public_path__ + "img/play.c1d8a631.png";